import httpclient from 'libs/Axios';

const getClientDetails = () => {
  const userAgent = window.navigator.userAgent;
  const deviceType = /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent)
    ? 'Mobile'
    : 'Desktop';
  const browserName = /Edg\//.test(userAgent)
    ? 'Microsoft Edge'
    : /Chrome\//.test(userAgent)
      ? 'Google Chrome'
      : /Firefox\//.test(userAgent)
        ? 'Mozilla Firefox'
        : /Safari\//.test(userAgent)
          ? 'Safari'
          : 'Other';
  const osName = /Android ([^;)]+)/.exec(userAgent)?.[1]
    ? `Android ${/Android ([^;)]+)/.exec(userAgent)?.[1]}`
    : /iPhone|iPad|iPod/.test(userAgent)
      ? 'iOS'
      : /Windows NT/.test(userAgent)
        ? 'Windows'
        : /Mac OS X/.test(userAgent)
          ? 'macOS'
          : /Linux/.test(userAgent)
            ? 'Linux'
            : 'Other';

  return { device_type: deviceType, browser_name: browserName, os_name: osName };
};

const mapGender = (gender: string) => {
  if (gender === 'Boy') return 'MALE';
  if (gender === 'Girl') return 'FEMALE';
  return 'PREFER_NOT_TO_SAY';
};

export const upsertLiveDemoLead = async (data: any, authData: any) => {
  if (!authData?.INSTITUTE_ID || !authData?.BRANCH_ID) {
    throw new Error('Your institute or branch session is missing. Please sign in again.');
  }

  const query = new URLSearchParams(window.location.search);
  const payload = {
    ...getClientDetails(),
    utm_source: query.get('utm_source') || 'LIVE_DEMO',
    student_name: data.studentName.trim(),
    parent_name: data.primaryParent.trim(),
    student_gender: mapGender(data.gender),
    student_age: Number(data.age),
    joining_class: data.target || data.grade,
    current_school: '',
    address: '',
    email_id: '',
    mobile_number: data.whatsapp.trim(),
  };

  const response = await httpclient().post('/master/upsertLead', payload, {
    suppressSuccessNotification: true,
    headers: {
      'branch-id': authData.BRANCH_ID,
      'institute-id': authData.INSTITUTE_ID,
    },
  });

  if (response?.data?.code !== 200 || !response?.data?.data?.is_form_submitted) {
    throw new Error(response?.data?.message || 'The lead could not be submitted. Please try again.');
  }

  return response.data.data;
};
